var _g, _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6, _path7, _circle, _path8, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 112 112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h18v21H33z",
    fill: "url(#m)",
    opacity: 0.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m49 33h2v20h-2z",
    fill: "#6AC34B",
    opacity: 0.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 22,
    height: 22,
    rx: 4.929,
    stroke: "url(#l)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59h18v21H61z",
    fill: "url(#k)",
    opacity: 0.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m77 60h2v20h-2z",
    fill: "#6AC34B",
    opacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 59,
    width: 22,
    height: 22,
    rx: 4.929,
    stroke: "url(#j)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m70.875 32 8.284 18.669a1 1 0 0 1-.864 1.404l-16.672.839a1 1 0 0 1-.936-1.463L70.875 32z",
    fill: "url(#i)",
    opacity: 0.17
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.274 33.271c.744-1.369 2.708-1.369 3.452 0l8.872 16.327c.711 1.309-.236 2.902-1.726 2.902H60.128c-1.49 0-2.437-1.593-1.726-2.902l8.872-16.327z",
    stroke: "#00A6CE",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m70.125 33.625-1 2 8.75 16.125 1.625-1.125-9.375-17z",
    fill: "#6AC34B",
    opacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 71,
    r: 10,
    fill: "url(#h)",
    opacity: 0.17
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.174 81.92c2.083-.532 3.969-1.77 5.386-3.538 1.416-1.767 2.291-3.972 2.499-6.296.207-2.325-.264-4.65-1.345-6.642-1.082-1.991-2.718-3.546-4.674-4.44 1.621 1.18 2.915 2.821 3.746 4.75.832 1.93 1.17 4.076.979 6.215a12.845 12.845 0 0 1-2.063 5.943c-1.16 1.75-2.724 3.135-4.528 4.008z",
    fill: "#6AC34B",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 71,
    r: 11,
    stroke: "#00A6CE",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 41.856,
    x2: 42.248,
    y1: 31.076,
    y2: 53.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBDB8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 41,
    x2: 41,
    y1: 31,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBDB8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 69.856,
    x2: 70.248,
    y1: 58.076,
    y2: 80.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBDB8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 69,
    x2: 69,
    y1: 58,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBDB8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 69.797,
    x2: 70.291,
    y1: 30.768,
    y2: 60.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBDB8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 42.84,
    x2: 43.16,
    y1: 60.12,
    y2: 81.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBDB8",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: -24,
    y: -24,
    width: 160,
    height: 160,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_454_6406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_454_6406",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightServices);
export default __webpack_public_path__ + "static/media/lightServices.cdf09ed32fcc97be5d64e0d3d407ae81.svg";
export { ForwardRef as ReactComponent };